import * as Sentry from "@sentry/browser";
import React, { Component } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import styled from "styled-components";
import Button from "sweet-web/components/universal/Button";
import { Label, Title } from "sweet-web/components/universal/Text";
import { Section } from "sweet-web/components/universal/View";
import { LogOut } from "sweet-web/redux/app/actions";

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

type OwnProps = {
  children: any;
};
type Props = OwnProps & RouteComponentProps;

type State = {
  hasError: boolean;
};
class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error) {
    // Display fallback UI
    this.setState({ hasError: true });
    console.log(error);
    // You can also log the error to an error reporting service
    Sentry.captureException(error);
  }

  resetApp = () => {
    this.props.history.push("/reset");
    window.location.reload(false);
  };

  render() {
    if (this.state.hasError) {
      return (
        <Wrapper>
          <Section style={{ width: 300 }}>
            <Title>Something went wrong</Title>
            <Label>
              Our team has been notified and the bug should be fixed soon
            </Label>
            <Button title="Refresh App" onClick={this.resetApp} />
          </Section>
        </Wrapper>
      );
    }

    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
